import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $toasts, toastDismissed } from '../../entities/notifications';
import { Toast, ToastViewport } from '../../shared/ui';

/** Renders queued notifications. Toast actions fire their Effector events (e.g. undo). */
export function Toaster() {
  const { t } = useTranslation();
  const [toasts, dismiss] = useUnit([$toasts, toastDismissed]);
  return (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={t(toast.message, toast.params ?? {})}
          tone={toast.tone ?? 'neutral'}
          closeLabel={t('common.close')}
          {...(toast.action
            ? {
                action: {
                  label: t(toast.action.label),
                  onAction: () => {
                    toast.action?.event();
                  },
                },
              }
            : {})}
          onOpenChange={(open) => {
            if (!open) dismiss(toast.id);
          }}
        />
      ))}
      <ToastViewport label={t('app.name')} />
    </>
  );
}
